﻿import { IHlaAllele } from "@nkr/models/hla"

export interface IRecipientPostTransplant {
    id: number,
    centerId: number,
    alias: string,
    wasDesensitized: boolean,
    desensitizationType: string,
    primaryNonFunction: boolean,
    donatedBy: number,
    transportationCost: number,
    charterVendor: string,
    shippedMethod: number,
    courierInvoiceNumber: string,
    isKflMatch: false,
    isWillingToMeetDonor: string,
    isSharingGfAndCreatinine: string,
    unosCPRA: number,
    exportableDaysInNkr: number,
    wasPreviouslySensitized: boolean,
    deathDate: string,
    isAlive: boolean,
    primaryCauseOfDeath: string,
    secondaryCauseOfDeath: string,
    rejectionEpisodes: false,
    rejectionEpisodeDetail: string,
    lostToFollowup: false,
    admitCreatinine: number
    admitCreatinineDate: string,
    creatinineWeek: number,
    creatinineWeekDate: string,
    creatinineMonth: number,
    creatinineMonthDate: string,
    creatinine6Month: string,
    creatinine6MonthDate: string,
    creatinineYear: string,
    creatinineYearDate: string,
    creatinineYear2: string,
    creatinineYear2Date: string,
    creatinineYear3: string,
    creatinineYear3Date: string,
    creatinineYear4: string,
    creatinineYear4Date: string,
    creatinineYear5: string,
    creatinineYear5Date: string,
    creatinineYear6: string,
    creatinineYear6Date: string,
    creatinineYear7: string,
    creatinineYear7Date: string,
    creatinineYear8: string,
    creatinineYear8Date: string,
    creatinineYear9: string,
    creatinineYear9Date: string,
    creatinineYear10: string,
    creatinineYear10Date: string,
    hadDelayedGraftFunction: boolean,
    graftSurvival: boolean,
    graftFailureDate: string,
    graftFailureReason: number,
    donorsUnosId: number,
    desensitization1: boolean,
    desensitization2: boolean,
    desensitization3: boolean,
    swapType: number,
    transplantDate: string,
    courierJobNumber: string,
    logisticsProvider: string,
    kflFollowupOptOut: boolean,
    hasDeNovoDSA: boolean,
    deNovoDSADate: string,
    deNovoDSA: string,
    deNovoDSAMFI: number
}

export interface IRecipientProfilePostTransplantData {
    isActive: boolean,

    patientType: string,
    swapType: number,
    transplantDate: string,
    shippedMethod: number,
    courierJobNumber: string,
    isKflMatch: boolean,
    logisticsProvider: string,
    transportationCost: string,

    isWillingToMeetDonor: boolean,
    isSharingGfAndCreatinine: boolean,

    transplantedDonor: {
        id: number,
        medChartUploadPath: string,
        ctReportUploadPath: string,
        hasCtScanOnline: string,
        rawTypingUploadPath: string,
        centerAboUploadPath: string,
        vrlAboUploadPath: string,
        vrlAboMolecularUploadPath: string,
        vrlAboA2ConfirmatoryUploadPath: string,
        vrlHlaUploadPath: string,
        serologyUploadPath: string,
        isExportable: boolean,
        covidTestUpload: string,
        aboASubType: number,
        histogeneticsRawTypingFile: string
    },

    donorTyping: IHlaAllele[],
    kflFollowupOptOut: boolean
    hasDeNovoDSA: boolean,
    deNovoDSADate: string,
    deNovoDSA: string,
    deNovoDSAMFI: number,
    histogeneticsRawTypingFile: string,

    unosCPRA: string,
    exportableDaysInNkr: number,
    wasPreviouslySensitized: boolean,
    coldIschemicHours: number,
    coldIschemicMinutes: number,
    packagingRemovalDateTime: string,
    reperfusionDateTime: string,
    immediateKidneyFunction: boolean,
    donorsUnosId: string,

    graftSurvival: boolean,
    graftFailureDate: string,
    graftFailureReason: string,
    graftFailureReasonOther: string,
    hadDelayedGraftFunction: boolean,
    primaryNonFunction: boolean,

    donatedBy: number,
    isAlive: boolean,
    deathDate: string,
    primaryCauseOfDeath: string,
    secondaryCauseOfDeath: string,

    rejectionEpisodes: number,
    rejectionEpisodeDetail: string,
    rejectionDueToNonCompliance: number,
    
    lostToFollowup: boolean,

    wasDesensitized: boolean,
    desensitizationType: string,

    desensitization: number[],

    doesGraftFailureQuestions: boolean,

    admitCreatinine: string,
    admitCreatinineDate: string,
    creatinineWeek: string,
    creatinineWeekDate: string,
    creatinineMonth: string,
    creatinineMonthDate: string,
    creatinine6Month: string,
    creatinine6MonthDate: string,
    creatinineYear: string,
    creatinineYearDate: string,
    creatinineYear2: string,
    creatinineYear2Date: string,
    creatinineYear3: string,
    creatinineYear3Date: string,
    creatinineYear4: string,
    creatinineYear4Date: string,
    creatinineYear5: string,
    creatinineYear5Date: string,
    creatinineYear6: string,
    creatinineYear6Date: string,
    creatinineYear7: string,
    creatinineYear7Date: string,
    creatinineYear8: string,
    creatinineYear8Date: string,
    creatinineYear9: string,
    creatinineYear9Date: string,
    creatinineYear10: string,
    creatinineYear10Date: string,
}

export interface IRecipientProfilePostTransplantDataRequest {
    shippedMethod: number,
    courierJobNumber: string,
    isKflMatch: boolean,
    transportationCost: number,

    isWillingToMeetDonor: boolean,
    isSharingGfAndCreatinine: boolean,

    kflFollowupOptOut: boolean
    hasDeNovoDSA: boolean,
    deNovoDSADate: string,
    deNovoDSA: string,
    deNovoDSAMFI: number,

    unosCPRA: string,
    exportableDaysInNkr: number,
    wasPreviouslySensitized: boolean,
    coldIschemicHours: number,
    coldIschemicMinutes: number,
    donorsUnosId: string,

    graftSurvival: boolean,
    graftFailureDate: string,
    graftFailureReason: string,
    graftFailureReasonOther: string,
    rejectionDueToNonCompliance: boolean,
    hadDelayedGraftFunction: boolean,
    primaryNonFunction: boolean,

    donatedBy: number,
    isAlive: boolean,
    deathDate: string,
    primaryCauseOfDeath: string,
    secondaryCauseOfDeath: string,
    rejectionEpisodes: boolean,
    rejectionEpisodeDetail: string,
    lostToFollowup: boolean,

    wasDesensitized: boolean,
    desensitizationType: string,

    desensitization1: number,
    desensitization2: number,
    desensitization3: number,

    admitCreatinine: string,
    admitCreatinineDate: string,
    creatinineWeek: string,
    creatinineWeekDate: string,
    creatinineMonth: string,
    creatinineMonthDate: string,
    creatinine6Month: string,
    creatinine6MonthDate: string,
    creatinineYear: string,
    creatinineYearDate: string,
    creatinineYear2: string,
    creatinineYear2Date: string,
    creatinineYear3: string,
    creatinineYear3Date: string,
    creatinineYear4: string,
    creatinineYear4Date: string,
    creatinineYear5: string,
    creatinineYear5Date: string,
    creatinineYear6: string,
    creatinineYear6Date: string,
    creatinineYear7: string,
    creatinineYear7Date: string,
    creatinineYear8: string,
    creatinineYear8Date: string,
    creatinineYear9: string,
    creatinineYear9Date: string,
    creatinineYear10: string,
    creatinineYear10Date: string,

    swapType: number,

    packagingRemovalDateTime: string,
    reperfusionDateTime: string,
    immediateKidneyFunction: boolean,

    transplantDate: string,
}